module.exports = __webpack_public_path__ + "img/header-engagementRingsHalo.78b1ee9.jpg";